import Phaser from 'phaser';

const lockedScenes = new Set<Phaser.Scene>();

function sceneHasInput(scene?: Phaser.Scene): scene is Phaser.Scene {
  return !!scene && !!scene.sys && !!scene.input;
}

function enableSceneInput(scene: Phaser.Scene): void {
  try {
    scene.input.enabled = true;
    if (scene.input.keyboard) scene.input.keyboard.enabled = true;
  } catch {
    // scene sudah dihancurkan
  }
}

function disableSceneInput(scene: Phaser.Scene): void {
  try {
    scene.input.enabled = false;
    try {
      scene.input.resetPointers();
    } catch {
      // ignore
    }
  } catch {
    // scene sudah dihancurkan
  }
}

/** Kunci/lepas input Phaser saat overlay HTML aktif. Release selalu idempotent. */
export class OverlayInputLock {
  static acquire(scene: Phaser.Scene): void {
    if (!sceneHasInput(scene)) return;
    if (!lockedScenes.has(scene)) {
      disableSceneInput(scene);
      lockedScenes.add(scene);
    }
  }

  static release(scene?: Phaser.Scene): void {
    if (!scene) return;
    if (lockedScenes.has(scene)) {
      lockedScenes.delete(scene);
      if (sceneHasInput(scene)) enableSceneInput(scene);
    }
  }

  static releaseAll(): void {
    lockedScenes.forEach((scene) => {
      if (sceneHasInput(scene)) enableSceneInput(scene);
    });
    lockedScenes.clear();
  }
}
